<template>
	<div>
		<div v-if="!isLoading" class="__student-detail pb-30">
			<div class="__goal-management-student-detail p-10 md-down:px-4">
				<div class="flex items-center justify-between">
					<div
						class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
						"
					>
						<router-link
							:to="{ name: routerName.TRANSFERRED_DATA }"
						>
							Xem hồ sơ cũ
						</router-link>
						<div class="__breadcrumbs__decorate">
							<DaIcon
								name="das--chevron-down"
								class="transform -rotate-90 h-3 w-3 mx-2"
							/>
						</div>
						<div>Xem báo cáo</div>
					</div>
					<button
						@click="exit"
						type="button"
						class="
							button-p
							text-center
							w-fit
							btn--text
							text-neutral-500
							hover:text-neutral-600
						"
					>
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							class="mr-2 text-neutral-400"
						>
							<path
								d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
								fill="currentColor"
							/>
							<path
								d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
								fill="currentColor"
							/>
						</svg>
						Thoát
					</button>
				</div>
				<div class="__goal-management-student-detail__header pt-5">
					<div
						class="
							flex
							justify-between
							items-center
							w-full
							md-down:flex-col md-down:items-start
							gap-8
						"
					>
						<div class="flex items-center">
							<div class="relative">
								<img
									style="min-width: 56px"
									class="
										shadow-sm
										inline-block
										h-14
										w-14
										rounded-full
									"
									:src="student?.profile_photo?.w200"
									v-if="student?.profile_photo?.w200"
								/>
								<span
									style="min-width: 56px"
									v-else
									class="
										inline-flex
										items-center
										justify-center
										h-14
										w-14
										rounded-full
									"
									:style="{
										background:
											student?.profile_photo?.default
												?.color,
									}"
								>
									<span
										class="
											font-medium
											leading-none
											text-white text-4xl
										"
										>{{
											student?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div
									v-if="student.state !== 'active'"
									style="
										min-width: 56px;
										background-color: rgba(
											241,
											162,
											103,
											0.5
										);
									"
									class="
										absolute
										transform
										-translate-x-1/2 -translate-y-1/2
										top-1/2
										left-1/2
										h-14
										w-14
										rounded-full
										flex
										items-center
										justify-center
									"
								>
									<svg
										width="32"
										height="32"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
											fill="#FAF5F1"
										/>
									</svg>
								</div>
							</div>
							<div class="ml-4">
								<div
									class="
										font-bold
										text-neutral-700 text-4xl
										md-down:text-2xl
									"
								>
									{{ student?.name }}
								</div>
								<div
									v-if="dateData"
									class="
										text-green-500
										font-semibold
										text-xs
										uppercase
										letter-spacing-8
									"
								>
									{{ dateData }}
								</div>
							</div>
						</div>
						<div>
							<button
								@click="toDetail"
								type="button"
								class="button-p text-center btn--ghost"
							>
								Xem hồ sơ học sinh
							</button>
						</div>
					</div>
					<div class="mt-10">
						<div class="border-b border-neutral-200">
							<nav
								class="-mb-px flex space-x-8 tabs"
								aria-label="Tabs"
							>
								<div
									@click="
										toPage(
											routerName.OLD_STUDENT_DATA_LESSON
										)
									"
									:class="{
										'router-link-exact-active':
											$route.name ===
											routerName.OLD_STUDENT_DATA_LESSON,
									}"
									class="
										border-transparent
										text-neutral-500
										hover:text-yellow-700
										hover:border-yellow-500
										whitespace-nowrap
										py-3
										px-1
										border-b-2
										font-semibold
										cursor-pointer
									"
								>
									Báo cáo cá nhân
								</div>
								<div
									@click="
										toPage(
											routerName.OLD_STUDENT_DATA_DAYCARE
										)
									"
									:class="{
										'router-link-exact-active':
											$route.name ===
											routerName.OLD_STUDENT_DATA_DAYCARE,
									}"
									class="
										border-transparent
										text-neutral-500
										hover:text-yellow-700
										hover:border-yellow-500
										whitespace-nowrap
										py-3
										px-1
										border-b-2
										font-semibold
										cursor-pointer
									"
								>
									Báo cáo bán trú
								</div>
								<div
									@click="
										toPage(routerName.OLD_STUDENT_DATA_WEEK)
									"
									:class="{
										'router-link-exact-active':
											$route.name ===
											routerName.OLD_STUDENT_DATA_WEEK,
									}"
									class="
										border-transparent
										text-neutral-500
										hover:text-yellow-700
										hover:border-yellow-500
										whitespace-nowrap
										py-3
										px-1
										border-b-2
										font-semibold
										cursor-pointer
									"
								>
									Báo cáo tuần
								</div>
								<div
									@click="
										toPage(routerName.OLD_STUDENT_DATA_PLAN)
									"
									class="
										border-transparent
										text-neutral-500
										hover:text-yellow-700
										hover:border-yellow-500
										whitespace-nowrap
										py-3
										px-1
										border-b-2
										font-semibold
										cursor-pointer
									"
									:class="{
										'router-link-exact-active':
											$route.name ===
											routerName.OLD_STUDENT_DATA_PLAN,
									}"
								>
									Báo cáo tháng
								</div>
							</nav>
						</div>
					</div>
				</div>
			</div>
			<div
				class="
					__goal-management-student-detail__overview
					px-10
					pb-24
					md-down:px-4
				"
			>
				<router-view></router-view>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import Loading from '@/components/common/Loading';
import { $api } from '@/services';
import DaIcon from '@/components/elements/daIcon/DaIcon';
import { _ROUTER_NAME } from '@/enums';

export default {
	name: 'OldStudentData',

	components: { DaIcon, Loading },

	computed: {
		id() {
			return this.$route.params.id;
		},

		routerName() {
			return _ROUTER_NAME;
		},

		oldPayload() {
			return {
				'x-cross': this.$route.query.org_id,
			};
		},

		is_old_data() {
			return this.$route.query.is_old_data === 'true';
		},

		dateData() {
			const join_date = this.$route.query.join_date;
			const left_date = this.$route.query.left_date;
			if (!join_date) {
				return '';
			}
			return `${this.$filters.formatDate2(join_date)} - ${
				left_date ? this.$filters.formatDate2(left_date) : 'Hiện tại'
			} | Đã học ${this.$filters.monthDiff(join_date, left_date)} tháng`;
		},
	},

	created() {
		this.getStudentDetail();
	},

	data() {
		return {
			isLoading: true,
			student: {},
		};
	},

	methods: {
		async getStudentDetail() {
			try {
				const {
					data: { data },
				} = await $api.student.getStudent(
					this.id,
					this.is_old_data ? this.oldPayload : null
				);
				this.student = data;
			} catch (err) {
				console.log(err?.response?.data?.errors || err.message);
			} finally {
				this.isLoading = false;
			}
		},

		toPage(name) {
			this.$router.push({
				name,
				query: {
					...this.$route.query,
				},
			});
		},

		exit() {
			const new_id = this.$route.query.new_id;
			this.$router.push({
				path: `/record/student/${new_id}/staff-list`,
			});
		},

		toDetail() {
			const query = this.$route.query;
			const params = this.$route.params;
			return this.$router.push({
				path: `/record/student/${params?.id}/staff-list`,
				query: {
					...query,
				},
			});
		},
	},
};
</script>

<style scoped lang="scss">
.tabs {
	.router-link-exact-active {
		@apply text-yellow-700 border-yellow-500;
	}
}
</style>
